import { render, staticRenderFns } from "./ContractorRegistractionModal.vue?vue&type=template&id=b57a03ec&scoped=true&"
import script from "./ContractorRegistractionModal.vue?vue&type=script&lang=ts&"
export * from "./ContractorRegistractionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57a03ec",
  null
  
)

export default component.exports